"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSpendingByCategoryData = void 0;
const immutable_1 = require("immutable");
const selectors_1 = require("data/spending/selectors");
const utils_1 = require("data/transactions/utils");
const buildSpendingByCategoryData = (spendingReportData, colorsFromTheme, accountsById) => {
    var _a, _b;
    if (!spendingReportData) {
        return (0, selectors_1.createDummyDisplayData)('Loading...');
    }
    const allTxns = spendingReportData.get('allTxns');
    if (!(allTxns === null || allTxns === void 0 ? void 0 : allTxns.size)) {
        return (0, selectors_1.createDummyDisplayData)('No spending to display');
    }
    const allTotal = spendingReportData.get('total');
    const chartData = spendingReportData.get('chartData');
    const subGroups = ((_b = (_a = chartData === null || chartData === void 0 ? void 0 : chartData.totals) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.subgroups) || [];
    const uncategorizedTxnsData = subGroups.find((txn) => txn.groupKey === 'Uncategorized');
    const uncategorizedTxns = uncategorizedTxnsData ? {
        amount: uncategorizedTxnsData.total,
        coaName: uncategorizedTxnsData.groupKey,
        coaPathName: uncategorizedTxnsData.groupKey,
        txns: [...uncategorizedTxnsData.txns],
    } : {};
    return {
        allTransactions: allTxns,
        byCategory: subGroups.map((group, index) => {
            const txnsByCategory = immutable_1.List.of(group.txns);
            const filterCriteria = new selectors_1.CategoryFilterCriteria(group.categoryId, null, group.groupKey, null);
            return {
                x: group.groupKey,
                y: Math.abs(group.total / allTotal),
                total: group.total * -1,
                coaPathName: group.groupKey,
                txnsByCategory,
                currency: (0, utils_1.getSharedCurrency)(txnsByCategory, accountsById),
                filterCriteria,
                color: filterCriteria.coaNodeSet || filterCriteria.parentCoaNodeId
                    ? colorsFromTheme[index] : filterCriteria.color || colorsFromTheme[index],
            };
        }),
        total: allTotal,
        uncategorizedTxns,
    };
};
exports.buildSpendingByCategoryData = buildSpendingByCategoryData;
